// Lucide icon categories for the IconPicker's grouped browse view.
//
// Provenance: Lucide ships an official `categories` array in each icon's
// metadata JSON (https://github.com/lucide-icons/lucide, icons/<name>.json) —
// these groups are Lucide's taxonomy, not hand-authored here. This file is
// generated: the metadata is extracted and intersected with the icon modules
// the installed lucide-react version actually ships (so every name renders),
// and icons Lucide leaves uncategorized are collected under "Other". Deprecated
// aliases are left out.
//
// Regenerate with `yarn generate:icon-categories` (after a lucide-react bump)
// rather than editing by hand.
//
// Shape: ordered [{ key, label, names: string[] }]; a name may appear in more
// than one category (it renders under each).

export const ICON_CATEGORIES = [
  {
    key: "accessibility",
    label: "Accessibility",
    names: [
      "accessibility",
      "ad",
      "baby",
      "badge-info",
      "badge-question-mark",
      "circle-question-mark",
      "closed-caption",
      "contrast",
      "ear",
      "ear-off",
      "eclipse",
      "eye",
      "eye-closed",
      "eye-dashed",
      "eye-off",
      "glasses",
      "hand",
      "info",
      "life-buoy",
      "moon",
      "moon-star",
      "mouth",
      "mouth-off",
      "person-standing",
      "scan-eye",
      "scan-search",
      "speech",
      "sun",
      "sun-dim",
      "sun-medium",
      "sun-moon",
      "transgender",
      "zoom-in",
      "zoom-out",
    ],
  },
  {
    key: "account",
    label: "Account",
    names: [
      "activity",
      "at-sign",
      "award",
      "badge",
      "badge-alert",
      "badge-info",
      "ban",
      "bell",
      "bell-check",
      "bell-dot",
      "book-user",
      "bookmark",
      "bookmark-check",
      "bookmark-minus",
      "bookmark-off",
      "bookmark-plus",
      "bookmark-x",
      "briefcase-plus",
      "building",
      "building-complex",
      "building-complex-plus",
      "cake",
      "circle-user",
      "circle-user-round",
      "cog",
      "contact",
      "contact-round",
      "cookie",
      "credit-card",
      "credit-card-check",
      "credit-card-minus",
      "credit-card-plus",
      "credit-card-x",
      "face-slightly-frowning",
      "face-slightly-smiling",
      "file-user",
      "fingerprint-pattern",
      "flag",
      "flag-off",
      "gift",
      "hand-coins",
      "handshake",
      "hat-glasses",
      "heart-handshake",
      "heart-minus",
      "heart-plus",
      "id-card",
      "id-card-lanyard",
      "inbox",
      "key",
      "key-round",
      "key-square",
      "link",
      "link-2",
      "log-in",
      "log-out",
      "mail",
      "mail-clock",
      "map-pin",
      "map-pin-check",
      "map-pin-check-inside",
      "map-pin-house",
      "map-pin-minus",
      "map-pin-minus-inside",
      "map-pin-pen",
      "map-pin-plus",
      "map-pin-plus-inside",
      "map-pin-search",
      "map-pin-x",
      "map-pin-x-inside",
      "map-pinned",
      "menu",
      "message-circle-check",
      "message-circle-dashed-check",
      "message-circle-x",
      "message-square-check",
      "notebook-tabs",
      "pin",
      "rotate-ccw-key",
      "scan-eye",
      "scan-face",
      "scan-qr-code",
      "settings",
      "settings-2",
      "share",
      "share-2",
      "shield",
      "shield-alert",
      "shield-ban",
      "shield-check",
      "shield-cog",
      "shield-cog-corner",
      "shield-ellipsis",
      "shield-half",
      "shield-keyhole",
      "shield-minus",
      "shield-off",
      "shield-plus",
      "shield-question-mark",
      "shield-user",
      "shield-x",
      "sliders-horizontal",
      "sliders-vertical",
      "square-user",
      "square-user-round",
      "star",
      "star-check",
      "star-minus",
      "star-plus",
      "star-x",
      "tag",
      "tag-plus",
      "tag-x",
      "tags",
      "thumbs-down",
      "thumbs-up",
      "ticket",
      "tickets",
      "toggle-left",
      "toggle-right",
      "user",
      "user-check",
      "user-cog",
      "user-group",
      "user-key",
      "user-lock",
      "user-minus",
      "user-pen",
      "user-plus",
      "user-round",
      "user-round-arrow-left",
      "user-round-check",
      "user-round-cog",
      "user-round-group",
      "user-round-key",
      "user-round-minus",
      "user-round-pen",
      "user-round-plus",
      "user-round-search",
      "user-round-x",
      "user-search",
      "user-shield",
      "user-star",
      "user-x",
      "users",
      "users-round",
      "venetian-mask",
      "vibrate",
      "vibrate-off",
      "wallet",
      "wallet-cards",
      "wallet-minimal",
      "wallpaper",
      "waypoints",
      "webhook",
      "webhook-off",
      "wrench",
      "wrench-off",
    ],
  },
  {
    key: "animals",
    label: "Animals",
    names: [
      "bird",
      "birdhouse",
      "bone",
      "bone-fracture",
      "bug",
      "bug-off",
      "bug-play",
      "cat",
      "dog",
      "egg",
      "feather",
      "fish",
      "fish-off",
      "fish-symbol",
      "origami",
      "panda",
      "paw-print",
      "rabbit",
      "rat",
      "shell",
      "shrimp",
      "shrimp-off",
      "snail",
      "squirrel",
      "turtle",
      "worm",
    ],
  },
  {
    key: "arrows",
    label: "Arrows",
    names: [
      "arrow-big-down",
      "arrow-big-down-dash",
      "arrow-big-left",
      "arrow-big-left-dash",
      "arrow-big-right",
      "arrow-big-right-dash",
      "arrow-big-up",
      "arrow-big-up-dash",
      "arrow-down",
      "arrow-down-0-1",
      "arrow-down-1-0",
      "arrow-down-a-z",
      "arrow-down-from-line",
      "arrow-down-left",
      "arrow-down-narrow-wide",
      "arrow-down-right",
      "arrow-down-to-dot",
      "arrow-down-to-line",
      "arrow-down-up",
      "arrow-down-wide-narrow",
      "arrow-down-z-a",
      "arrow-left",
      "arrow-left-from-line",
      "arrow-left-right",
      "arrow-left-to-line",
      "arrow-right",
      "arrow-right-from-line",
      "arrow-right-left",
      "arrow-right-to-line",
      "arrow-up",
      "arrow-up-0-1",
      "arrow-up-1-0",
      "arrow-up-a-z",
      "arrow-up-down",
      "arrow-up-from-dot",
      "arrow-up-from-line",
      "arrow-up-left",
      "arrow-up-narrow-wide",
      "arrow-up-right",
      "arrow-up-to-line",
      "arrow-up-wide-narrow",
      "arrow-up-z-a",
      "arrows-up-from-line",
      "calendar-chevrons-right",
      "calendar-sync",
      "chevron-down",
      "chevron-first",
      "chevron-last",
      "chevron-left",
      "chevron-right",
      "chevron-up",
      "chevrons-down",
      "chevrons-down-up",
      "chevrons-left",
      "chevrons-left-right",
      "chevrons-right",
      "chevrons-right-left",
      "chevrons-up",
      "chevrons-up-down",
      "circle-arrow-down",
      "circle-arrow-left",
      "circle-arrow-out-down-left",
      "circle-arrow-out-down-right",
      "circle-arrow-out-up-left",
      "circle-arrow-out-up-right",
      "circle-arrow-right",
      "circle-arrow-up",
      "circle-chevron-down",
      "circle-chevron-left",
      "circle-chevron-right",
      "circle-chevron-up",
      "circle-fading-arrow-up",
      "clipboard-copy",
      "clipboard-paste",
      "clock-arrow-right",
      "cloud-backup",
      "cloud-download",
      "cloud-sync",
      "cloud-upload",
      "corner-down-left",
      "corner-down-right",
      "corner-left-down",
      "corner-left-up",
      "corner-right-down",
      "corner-right-up",
      "corner-up-left",
      "corner-up-right",
      "database-backup",
      "decimals-arrow-left",
      "decimals-arrow-right",
      "delete",
      "download",
      "expand",
      "external-link",
      "fast-forward",
      "file-down",
      "file-input",
      "file-output",
      "file-up",
      "fold-horizontal",
      "fold-vertical",
      "folder-down",
      "folder-input",
      "folder-output",
      "folder-sync",
      "folder-up",
      "git-compare-arrows",
      "git-pull-request-arrow",
      "git-pull-request-create-arrow",
      "hard-drive-download",
      "hard-drive-upload",
      "import",
      "iteration-ccw",
      "iteration-cw",
      "lasso-select",
      "layers-arrow-up",
      "list-chevrons-down-up",
      "list-chevrons-up-down",
      "log-in",
      "log-out",
      "maximize-2",
      "merge",
      "milestone",
      "minimize-2",
      "mouse-pointer",
      "mouse-pointer-2",
      "mouse-pointer-2-off",
      "mouse-pointer-ban",
      "mouse-pointer-click",
      "move",
      "move-diagonal",
      "move-diagonal-2",
      "move-down",
      "move-down-left",
      "move-down-right",
      "move-horizontal",
      "move-left",
      "move-right",
      "move-up",
      "move-up-left",
      "move-up-right",
      "move-vertical",
      "panel-bottom-close",
      "panel-bottom-open",
      "panel-left-close",
      "panel-left-open",
      "panel-right-close",
      "panel-right-open",
      "panel-top-close",
      "panel-top-open",
      "phone-forwarded",
      "phone-incoming",
      "phone-outgoing",
      "play",
      "redo",
      "redo-2",
      "redo-dot",
      "refresh-ccw",
      "refresh-ccw-dot",
      "refresh-cw",
      "refresh-cw-off",
      "repeat",
      "repeat-2",
      "repeat-off",
      "rewind",
      "rotate-ccw",
      "rotate-ccw-clock",
      "rotate-ccw-square",
      "rotate-cw",
      "rotate-cw-clock",
      "rotate-cw-square",
      "separator-horizontal",
      "separator-vertical",
      "shrink",
      "shuffle",
      "signpost",
      "signpost-big",
      "skip-back",
      "skip-forward",
      "spline-pointer",
      "split",
      "square-arrow-down",
      "square-arrow-down-left",
      "square-arrow-down-right",
      "square-arrow-left",
      "square-arrow-out-down-left",
      "square-arrow-out-down-right",
      "square-arrow-out-up-left",
      "square-arrow-out-up-right",
      "square-arrow-right",
      "square-arrow-right-enter",
      "square-arrow-right-exit",
      "square-arrow-up",
      "square-arrow-up-left",
      "square-arrow-up-right",
      "square-chevron-down",
      "square-chevron-left",
      "square-chevron-right",
      "square-chevron-up",
      "square-dashed-mouse-pointer",
      "square-mouse-pointer",
      "square-play",
      "step-back",
      "step-forward",
      "sunrise",
      "sunset",
      "text-wrap",
      "trending-down",
      "trending-up",
      "trending-up-down",
      "undo",
      "undo-2",
      "undo-dot",
      "unfold-horizontal",
      "unfold-vertical",
      "upload",
      "user-round-arrow-left",
      "wind-arrow-up",
    ],
  },
  {
    key: "buildings",
    label: "Buildings",
    names: [
      "anvil",
      "brick-wall",
      "bridge",
      "building",
      "building-complex",
      "building-complex-plus",
      "castle",
      "church",
      "dam",
      "dome",
      "factory",
      "fence",
      "graduation-cap",
      "hospital",
      "hotel",
      "house",
      "house-cog",
      "house-heart",
      "house-plug",
      "house-plus",
      "house-wifi",
      "houses",
      "landmark",
      "lighthouse",
      "mosque",
      "school",
      "store",
      "theater",
      "university",
      "utility-pole",
      "warehouse",
    ],
  },
  {
    key: "charts",
    label: "Charts",
    names: [
      "chart-area",
      "chart-bar",
      "chart-bar-big",
      "chart-bar-decreasing",
      "chart-bar-increasing",
      "chart-bar-stacked",
      "chart-candlestick",
      "chart-column",
      "chart-column-big",
      "chart-column-decreasing",
      "chart-column-increasing",
      "chart-column-stacked",
      "chart-gantt",
      "chart-line",
      "chart-network",
      "chart-no-axes-column",
      "chart-no-axes-column-decreasing",
      "chart-no-axes-column-increasing",
      "chart-no-axes-combined",
      "chart-no-axes-gantt",
      "chart-pie",
      "chart-scatter",
      "chart-spline",
      "equal-approximately-not",
      "folder-kanban",
      "kanban",
      "square-chart-gantt",
      "square-dashed-kanban",
      "square-kanban",
      "trending-down",
      "trending-up",
      "trending-up-down",
    ],
  },
  {
    key: "communication",
    label: "Communication",
    names: [
      "antenna",
      "audio-lines",
      "audio-lines-off",
      "audio-lines-x",
      "audio-waveform",
      "book-user",
      "camera",
      "camera-off",
      "card-sim",
      "cassette-tape",
      "cctv",
      "cctv-off",
      "chevrons-left-right-ellipsis",
      "circle-fading-plus",
      "contact",
      "contact-round",
      "ethernet-port",
      "face-slightly-smiling-plus",
      "hand-fist",
      "handshake",
      "headphone-off",
      "lectern",
      "mail-badge",
      "mail-clock",
      "messages-circle",
      "mic",
      "mic-audio-lines",
      "mic-off",
      "mic-signal",
      "mouth",
      "mouth-off",
      "newspaper",
      "nfc",
      "notebook",
      "notebook-dot",
      "notebook-tabs",
      "phone",
      "phone-call",
      "phone-forwarded",
      "phone-incoming",
      "phone-missed",
      "phone-off",
      "phone-outgoing",
      "presentation",
      "projector",
      "radar",
      "screen-share",
      "screen-share-off",
      "send",
      "send-horizontal",
      "smartphone-nfc",
      "speech",
      "spool",
      "spotlight",
      "switch-camera",
      "tv",
      "video",
      "video-off",
      "videotape",
      "volume",
      "volume-1",
      "volume-2",
      "volume-off",
      "volume-x",
      "webcam",
      "webcam-off",
    ],
  },
  {
    key: "connectivity",
    label: "Connectivity",
    names: [
      "airplay",
      "battery",
      "battery-charging",
      "battery-full",
      "battery-low",
      "battery-medium",
      "battery-warning",
      "bluetooth",
      "bluetooth-connected",
      "bluetooth-off",
      "bluetooth-searching",
      "book-user",
      "brick-wall-fire",
      "brick-wall-shield",
      "cable",
      "car-battery",
      "card-sim",
      "cassette-tape",
      "cast",
      "cctv",
      "cctv-off",
      "circle-power",
      "cloud-off",
      "contact",
      "contact-round",
      "globe-off",
      "globe-x",
      "headphone-off",
      "headphones",
      "headset",
      "house-wifi",
      "mic",
      "mic-off",
      "mic-signal",
      "midi-port",
      "monitor",
      "monitor-check",
      "monitor-cloud",
      "monitor-cog",
      "monitor-dot",
      "monitor-down",
      "monitor-off",
      "monitor-pause",
      "monitor-play",
      "monitor-smartphone",
      "monitor-speaker",
      "monitor-stop",
      "monitor-up",
      "monitor-x",
      "phone",
      "phone-call",
      "phone-forwarded",
      "phone-incoming",
      "phone-missed",
      "phone-off",
      "phone-outgoing",
      "power",
      "power-off",
      "rectangle-goggles",
      "router",
      "satellite",
      "satellite-dish",
      "screen-share",
      "screen-share-off",
      "send",
      "send-horizontal",
      "signal",
      "signal-high",
      "signal-low",
      "signal-medium",
      "signal-zero",
      "smartphone",
      "smartphone-charging",
      "square-power",
      "vibrate",
      "vibrate-off",
      "video",
      "video-off",
      "videotape",
      "voicemail",
      "volume",
      "volume-1",
      "volume-2",
      "volume-off",
      "volume-x",
      "webcam",
      "webcam-off",
      "wifi",
      "wifi-cog",
      "wifi-high",
      "wifi-low",
      "wifi-off",
      "wifi-pen",
      "wifi-sync",
      "wifi-zero",
      "zap",
      "zap-off",
    ],
  },
  {
    key: "cursors",
    label: "Cursors",
    names: [
      "circle-plus",
      "hand",
      "hand-grab",
      "lasso",
      "lasso-select",
      "loader",
      "loader-circle",
      "loader-pinwheel",
      "mouse-pointer",
      "mouse-pointer-2",
      "mouse-pointer-2-off",
      "mouse-pointer-ban",
      "mouse-pointer-click",
      "move",
      "move-diagonal",
      "move-diagonal-2",
      "move-horizontal",
      "move-vertical",
      "pen-tool",
      "pencil",
      "pencil-off",
      "pencil-sparkles",
      "plus",
      "pointer",
      "pointer-off",
      "sparkles",
      "spline-pointer",
      "square-dashed-mouse-pointer",
      "square-dashed-text",
      "square-mouse-pointer",
      "stamp",
      "text-cursor",
      "wand",
      "wand-sparkles",
    ],
  },
  {
    key: "design",
    label: "Design",
    names: [
      "a-arrow-down",
      "a-arrow-up",
      "a-large-small",
      "angle",
      "app-window",
      "app-window-mac",
      "axis-3d",
      "between-horizontal-end",
      "between-horizontal-start",
      "between-vertical-end",
      "between-vertical-start",
      "blend",
      "book-type",
      "bring-to-front",
      "brush",
      "brush-cleaning",
      "chart-no-axes-gantt",
      "columns-2",
      "columns-3",
      "columns-3-cog",
      "columns-4",
      "component",
      "contrast",
      "crop",
      "cylinder",
      "database-backup",
      "decimals-arrow-left",
      "decimals-arrow-right",
      "diameter",
      "dock",
      "drafting-compass",
      "eclipse",
      "eye",
      "eye-closed",
      "eye-dashed",
      "eye-off",
      "file-axis-3d",
      "file-box",
      "folder-kanban",
      "frame",
      "fullscreen",
      "gallery-horizontal",
      "gallery-horizontal-end",
      "gallery-thumbnails",
      "gallery-vertical",
      "gallery-vertical-end",
      "gap-horizontal",
      "gap-vertical",
      "grid-2x2",
      "grid-3x2",
      "grid-3x3",
      "hand-grab",
      "heart-x",
      "highlighter",
      "iteration-ccw",
      "iteration-cw",
      "kanban",
      "land-plot",
      "lasso",
      "lasso-select",
      "layer-arrow-down",
      "layer-arrow-up",
      "layers",
      "layers-2",
      "layers-arrow-down",
      "layers-arrow-up",
      "layers-minus",
      "layers-plus",
      "layout-arrow-down",
      "layout-arrow-right",
      "layout-dashboard",
      "layout-freeform",
      "layout-grid",
      "layout-grid-circles",
      "layout-list",
      "layout-panel-left",
      "line-squiggle",
      "line-style",
      "loader",
      "loader-pinwheel",
      "magnet",
      "maximize",
      "maximize-2",
      "minimize",
      "minimize-2",
      "mop-sparkles",
      "move-3d",
      "notebook",
      "origami",
      "paint-bucket",
      "paint-roller",
      "paintbrush",
      "paintbrush-vertical",
      "palette",
      "panel-top",
      "panels-top-left",
      "paperclip",
      "pen",
      "pen-line",
      "pen-off",
      "pen-tool",
      "pencil",
      "pencil-line",
      "pencil-off",
      "pencil-ruler",
      "pencil-sparkles",
      "pipette",
      "presentation",
      "proportions",
      "radius",
      "ratio",
      "rectangle-horizontal",
      "rectangle-vertical",
      "rotate-3d",
      "rotate-ccw",
      "rotate-ccw-square",
      "rotate-cw",
      "rotate-cw-square",
      "rows-2",
      "rows-3",
      "rows-4",
      "ruler",
      "ruler-dimension-line",
      "scale-3d",
      "scaling",
      "scan-box",
      "scan-square",
      "scissors",
      "scissors-line-dashed",
      "send-to-back",
      "slice",
      "spline",
      "spline-pointer",
      "spray-can",
      "square-bottom-dashed-scissors",
      "square-centerline-dashed-horizontal",
      "square-centerline-dashed-vertical",
      "square-chart-gantt",
      "square-dashed",
      "square-dashed-kanban",
      "square-dashed-plus",
      "square-dashed-top-solid",
      "square-dashed-x",
      "square-dashed-x-corner",
      "square-dimensions",
      "square-kanban",
      "square-off",
      "square-round-corner",
      "square-scissors",
      "squares-exclude",
      "squares-intersect",
      "squares-subtract",
      "squares-unite",
      "squircle-dashed",
      "stamp",
      "swatch-book",
      "tablet-smartphone",
      "tangent",
      "torus",
      "triangles-centerline-dashed-horizontal",
      "triangles-centerline-dashed-vertical",
      "vector-polygon",
      "vector-square",
      "view",
      "wand",
      "wand-sparkles",
      "zoom-in",
      "zoom-out",
    ],
  },
  {
    key: "development",
    label: "Development",
    names: [
      "ampersand",
      "ampersands",
      "app-window",
      "app-window-mac",
      "arrow-big-up",
      "arrow-big-up-dash",
      "arrow-down-to-line",
      "arrow-right-to-line",
      "arrow-up-from-line",
      "asterisk",
      "binary",
      "binoculars",
      "bitcoin",
      "blend",
      "blocks",
      "book",
      "book-alert",
      "book-bookmark",
      "book-check",
      "book-copy",
      "book-dashed",
      "book-down",
      "book-key",
      "book-lock",
      "book-minus",
      "book-open",
      "book-open-check",
      "book-open-text",
      "book-plus",
      "book-search",
      "book-up",
      "book-up-2",
      "bot",
      "bot-message-square",
      "bot-off",
      "box",
      "boxes",
      "braces",
      "brackets",
      "brain-circuit",
      "brain-cog",
      "bug",
      "bug-off",
      "bug-play",
      "case-lower",
      "case-upper",
      "chart-no-axes-gantt",
      "chevron-right",
      "circle-arrow-out-up-left",
      "circle-dashed",
      "circle-dashed-check",
      "circle-dot",
      "circle-dot-dashed",
      "circle-ellipsis",
      "circle-fading-arrow-up",
      "circle-plus",
      "circle-slash",
      "circle-slash-2",
      "circle-x",
      "circuit-board",
      "cloud-alert",
      "cloud-check",
      "cloud-cog",
      "code",
      "code-xml",
      "combine",
      "command",
      "component",
      "computer",
      "construction",
      "container",
      "copy-slash",
      "corner-down-right",
      "database",
      "database-arrow-down",
      "database-arrow-up",
      "database-backup",
      "database-check",
      "database-minus",
      "database-plus",
      "database-search",
      "database-x",
      "database-zap",
      "diff",
      "divide",
      "dock",
      "earth-lock",
      "eclipse",
      "ellipsis",
      "equal",
      "equal-approximately-not",
      "equal-not",
      "file-box",
      "file-braces",
      "file-braces-corner",
      "file-code",
      "file-code-corner",
      "file-diff",
      "file-digit",
      "file-sliders",
      "file-stack",
      "file-terminal",
      "flag-triangle-left",
      "flag-triangle-right",
      "folder-code",
      "folder-dot",
      "folder-kanban",
      "folder-open-dot",
      "folder-root",
      "form",
      "gallery-horizontal",
      "gallery-horizontal-end",
      "gallery-thumbnails",
      "gallery-vertical",
      "gallery-vertical-end",
      "gem",
      "git-branch",
      "git-branch-minus",
      "git-branch-plus",
      "git-commit-horizontal",
      "git-commit-vertical",
      "git-compare",
      "git-compare-arrows",
      "git-fork",
      "git-graph",
      "git-merge",
      "git-merge-conflict",
      "git-pull-request",
      "git-pull-request-arrow",
      "git-pull-request-closed",
      "git-pull-request-create",
      "git-pull-request-create-arrow",
      "git-pull-request-draft",
      "globe-code",
      "globe-lock",
      "hard-drive",
      "hard-drive-download",
      "hard-drive-upload",
      "hexagon",
      "kanban",
      "keyboard",
      "keyboard-off",
      "lambda",
      "library",
      "library-big",
      "line-dot-bottom-vertical",
      "line-dot-left-horizontal",
      "line-dot-right-horizontal",
      "line-dot-top-vertical",
      "list-indent-decrease",
      "list-indent-increase",
      "merge",
      "message-circle-code",
      "message-square-code",
      "message-square-diff",
      "milestone",
      "minus",
      "monitor-cloud",
      "monitor-pc",
      "network",
      "omega",
      "option",
      "package",
      "package-2",
      "package-check",
      "package-minus",
      "package-open",
      "package-plus",
      "package-search",
      "package-x",
      "panel-top",
      "panels-top-left",
      "parentheses",
      "percent",
      "pi",
      "playing-card",
      "playing-cards",
      "playing-cards-fan",
      "plug",
      "plug-2",
      "plus",
      "puzzle",
      "qr-code",
      "radical",
      "rectangle-circle",
      "rectangle-ellipsis",
      "refresh-ccw-dot",
      "regex",
      "rocket",
      "router",
      "rss",
      "save-check",
      "scan-square",
      "scroll",
      "scroll-text",
      "search-code",
      "server",
      "server-cog",
      "server-crash",
      "server-off",
      "server-plus",
      "shell",
      "shield",
      "shield-alert",
      "shield-ban",
      "shield-check",
      "shield-cog",
      "shield-cog-corner",
      "shield-ellipsis",
      "shield-half",
      "shield-keyhole",
      "shield-minus",
      "shield-off",
      "shield-plus",
      "shield-question-mark",
      "shield-user",
      "shield-x",
      "signpost",
      "signpost-big",
      "slash",
      "spell-check",
      "spell-check-2",
      "split",
      "square-asterisk",
      "square-bottom-dashed-scissors",
      "square-chart-gantt",
      "square-chevron-right",
      "square-code",
      "square-dashed-bottom",
      "square-dashed-bottom-code",
      "square-dashed-kanban",
      "square-dashed-mouse-pointer",
      "square-dashed-top-solid",
      "square-dashed-x",
      "square-dashed-x-corner",
      "square-dot",
      "square-function",
      "square-kanban",
      "square-library",
      "square-minus",
      "square-mouse-pointer",
      "square-pi",
      "square-plus",
      "square-radical",
      "square-round-corner",
      "square-scissors",
      "square-slash",
      "square-stack",
      "square-terminal",
      "square-text",
      "squircle-dashed",
      "table-properties",
      "tablet-smartphone",
      "telescope",
      "terminal",
      "toggle-left",
      "toggle-right",
      "tool-case",
      "toy-brick",
      "triangle-alert",
      "unplug",
      "user-shield",
      "variable",
      "waypoints",
      "webhook",
      "webhook-off",
      "workflow",
      "wrench",
      "wrench-off",
    ],
  },
  {
    key: "devices",
    label: "Devices",
    names: [
      "alarm-clock",
      "alarm-clock-check",
      "alarm-clock-minus",
      "alarm-clock-off",
      "alarm-clock-plus",
      "alarm-smoke",
      "antenna",
      "battery",
      "battery-charging",
      "battery-full",
      "battery-low",
      "battery-medium",
      "battery-plus",
      "battery-warning",
      "bell-electric",
      "bluetooth",
      "bluetooth-connected",
      "bluetooth-off",
      "bluetooth-searching",
      "boom-box",
      "cable",
      "calculator",
      "camera",
      "camera-off",
      "card-sim",
      "cassette-tape",
      "cast",
      "cctv",
      "cctv-off",
      "chevrons-left-right-ellipsis",
      "computer",
      "cpu",
      "database",
      "database-arrow-down",
      "database-arrow-up",
      "database-backup",
      "database-check",
      "database-minus",
      "database-plus",
      "database-search",
      "database-x",
      "database-zap",
      "diamond-minus",
      "diamond-plus",
      "disc",
      "disc-2",
      "disc-3",
      "disc-album",
      "drill",
      "drone",
      "drum",
      "earth-lock",
      "eject",
      "ethernet-port",
      "fingerprint-pattern",
      "flashlight",
      "flashlight-off",
      "gamepad",
      "gamepad-2",
      "gamepad-directional",
      "globe-lock",
      "globe-off",
      "globe-x",
      "gpu",
      "hard-drive",
      "hard-drive-download",
      "hard-drive-upload",
      "hd",
      "hdmi-port",
      "headphone-off",
      "headphones",
      "headset",
      "heater",
      "joystick",
      "keyboard",
      "keyboard-music",
      "keyboard-off",
      "laptop",
      "laptop-minimal",
      "laptop-minimal-check",
      "memory-stick",
      "mic",
      "mic-audio-lines",
      "mic-off",
      "mic-signal",
      "mic-vocal",
      "microchip",
      "midi-port",
      "monitor",
      "monitor-check",
      "monitor-cloud",
      "monitor-cog",
      "monitor-dot",
      "monitor-down",
      "monitor-off",
      "monitor-pause",
      "monitor-pc",
      "monitor-play",
      "monitor-smartphone",
      "monitor-speaker",
      "monitor-stop",
      "monitor-up",
      "monitor-x",
      "mouse",
      "mouse-left",
      "mouse-off",
      "mouse-right",
      "nfc",
      "pc-case",
      "phone",
      "phone-call",
      "phone-forwarded",
      "phone-incoming",
      "phone-missed",
      "phone-off",
      "phone-outgoing",
      "piano",
      "plug",
      "plug-2",
      "plug-zap",
      "presentation",
      "printer",
      "printer-3d",
      "printer-check",
      "printer-x",
      "projector",
      "proportions",
      "radio",
      "radio-off",
      "radio-receiver",
      "radio-tower",
      "rectangle-goggles",
      "robot-vacuum",
      "router",
      "satellite-dish",
      "scan",
      "scan-barcode",
      "scan-box",
      "scan-eye",
      "scan-face",
      "scan-line",
      "scan-qr-code",
      "scan-text",
      "screen-share",
      "screen-share-off",
      "server",
      "server-cog",
      "server-crash",
      "server-off",
      "server-plus",
      "smartphone",
      "smartphone-charging",
      "smartphone-nfc",
      "speaker",
      "spotlight",
      "square-minus",
      "switch-camera",
      "tablet",
      "tablet-smartphone",
      "toilet",
      "touchpad",
      "touchpad-off",
      "tv",
      "tv-minimal",
      "tv-minimal-play",
      "unplug",
      "usb",
      "usb-c-port",
      "vibrate",
      "vibrate-off",
      "video",
      "video-off",
      "videotape",
      "voicemail",
      "wallpaper",
      "washing-machine",
      "webcam",
      "webcam-off",
      "wifi",
      "wifi-cog",
      "wifi-high",
      "wifi-low",
      "wifi-off",
      "wifi-pen",
      "wifi-sync",
      "wifi-zero",
      "zap",
      "zap-off",
    ],
  },
  {
    key: "emoji",
    label: "Emoji",
    names: [
      "balloon",
      "biceps-flexed",
      "chess-bishop",
      "chess-king",
      "chess-knight",
      "chess-pawn",
      "chess-queen",
      "chess-rook",
      "face-angry",
      "face-expressionless",
      "face-grinning",
      "face-neutral",
      "face-slightly-frowning",
      "face-slightly-smiling",
      "face-slightly-smiling-plus",
      "hand-fist",
      "hand-helping",
      "hand-metal",
      "heart",
      "heart-crack",
      "heart-handshake",
      "leafy-green",
      "party-popper",
      "ribbon",
      "salad",
      "star",
      "star-check",
      "star-minus",
      "star-plus",
      "star-x",
      "thumbs-down",
      "thumbs-up",
      "zodiac-aquarius",
      "zodiac-aries",
      "zodiac-cancer",
      "zodiac-capricorn",
      "zodiac-gemini",
      "zodiac-leo",
      "zodiac-libra",
      "zodiac-ophiuchus",
      "zodiac-pisces",
      "zodiac-sagittarius",
      "zodiac-scorpio",
      "zodiac-taurus",
      "zodiac-virgo",
    ],
  },
  {
    key: "files",
    label: "Files",
    names: [
      "app-window",
      "app-window-mac",
      "archive",
      "archive-restore",
      "archive-x",
      "arrow-big-down-dash",
      "arrow-down-from-line",
      "arrow-down-to-line",
      "arrow-up-from-line",
      "arrow-up-to-line",
      "book-image",
      "braces",
      "brackets",
      "briefcase-plus",
      "calendar-fold",
      "cassette-tape",
      "chart-pie",
      "cloud-backup",
      "cloud-download",
      "cloud-sync",
      "cloud-upload",
      "combine",
      "diff",
      "dock",
      "download",
      "eject",
      "file",
      "file-archive",
      "file-axis-3d",
      "file-badge",
      "file-box",
      "file-braces",
      "file-braces-corner",
      "file-chart-column",
      "file-chart-column-increasing",
      "file-chart-line",
      "file-chart-pie",
      "file-check",
      "file-check-corner",
      "file-clock",
      "file-code",
      "file-code-corner",
      "file-cog",
      "file-diff",
      "file-digit",
      "file-down",
      "file-exclamation-point",
      "file-headphone",
      "file-heart",
      "file-image",
      "file-input",
      "file-key",
      "file-lock",
      "file-minus",
      "file-minus-corner",
      "file-music",
      "file-output",
      "file-pen",
      "file-pen-line",
      "file-play",
      "file-plus",
      "file-plus-corner",
      "file-question-mark",
      "file-scan",
      "file-search",
      "file-search-corner",
      "file-signal",
      "file-sliders",
      "file-spreadsheet",
      "file-stack",
      "file-symlink",
      "file-terminal",
      "file-text",
      "file-type",
      "file-type-corner",
      "file-up",
      "file-user",
      "file-video-camera",
      "file-volume",
      "file-x",
      "file-x-corner",
      "files",
      "folder",
      "folder-archive",
      "folder-bookmark",
      "folder-check",
      "folder-clock",
      "folder-closed",
      "folder-code",
      "folder-cog",
      "folder-dot",
      "folder-down",
      "folder-git",
      "folder-git-2",
      "folder-heart",
      "folder-input",
      "folder-kanban",
      "folder-key",
      "folder-lock",
      "folder-minus",
      "folder-open",
      "folder-open-dot",
      "folder-output",
      "folder-pen",
      "folder-plus",
      "folder-root",
      "folder-search",
      "folder-search-2",
      "folder-symlink",
      "folder-sync",
      "folder-tree",
      "folder-up",
      "folder-x",
      "folders",
      "gallery-horizontal-end",
      "gallery-vertical-end",
      "group",
      "hard-drive-download",
      "hard-drive-upload",
      "headphones",
      "headset",
      "image",
      "image-down",
      "image-minus",
      "image-off",
      "image-play",
      "image-plus",
      "image-up",
      "images",
      "import",
      "list-tree",
      "message-square-diff",
      "music",
      "music-2",
      "music-3",
      "music-4",
      "package",
      "package-2",
      "package-open",
      "package-search",
      "paperclip",
      "parentheses",
      "save",
      "save-all",
      "save-check",
      "save-off",
      "save-pen",
      "save-plus",
      "sheet",
      "shield-keyhole",
      "shredder",
      "square-bottom-dashed-scissors",
      "square-dashed-bottom",
      "square-dashed-bottom-code",
      "square-scissors",
      "square-sparkles",
      "square-stack",
      "table",
      "table-2",
      "table-cells-merge",
      "table-cells-split",
      "table-columns-split",
      "table-properties",
      "table-rows-split",
      "trash",
      "trash-off",
      "ungroup",
      "upload",
      "videotape",
      "wifi-cog",
    ],
  },
  {
    key: "finance",
    label: "Finance",
    names: [
      "armenian-dram",
      "badge-cent",
      "badge-dollar-sign",
      "badge-euro",
      "badge-indian-rupee",
      "badge-japanese-yen",
      "badge-percent",
      "badge-pound-sterling",
      "badge-russian-ruble",
      "badge-swiss-franc",
      "badge-turkish-lira",
      "bangladeshi-taka",
      "banknote",
      "banknote-arrow-down",
      "banknote-arrow-up",
      "banknote-check",
      "banknote-x",
      "bitcoin",
      "chart-candlestick",
      "circle-dollar-sign",
      "circle-euro",
      "circle-percent",
      "circle-pound-sterling",
      "credit-card",
      "credit-card-check",
      "credit-card-minus",
      "credit-card-plus",
      "credit-card-reader",
      "credit-card-x",
      "currency",
      "diamond-percent",
      "dollar-sign",
      "euro",
      "gem",
      "georgian-lari",
      "hand-coins",
      "handshake",
      "indian-rupee",
      "japanese-yen",
      "kazakh-tenge",
      "landmark",
      "nepali-rupee",
      "nfc",
      "percent",
      "philippine-peso",
      "piggy-bank",
      "pound-sterling",
      "receipt",
      "receipt-cent",
      "receipt-euro",
      "receipt-indian-rupee",
      "receipt-japanese-yen",
      "receipt-pound-sterling",
      "receipt-russian-ruble",
      "receipt-swiss-franc",
      "receipt-text",
      "receipt-turkish-lira",
      "russian-ruble",
      "saudi-riyal",
      "scale",
      "smartphone-nfc",
      "square-percent",
      "swiss-franc",
      "turkish-lira",
      "wallet",
      "wallet-cards",
      "wallet-minimal",
    ],
  },
  {
    key: "food-beverage",
    label: "Food Beverage",
    names: [
      "amphora",
      "apple",
      "banana",
      "barrel",
      "bean",
      "bean-off",
      "beef",
      "beef-off",
      "beer",
      "beer-off",
      "blender",
      "bottle-wine",
      "broccoli",
      "cake",
      "cake-slice",
      "can",
      "can-soda",
      "candy",
      "candy-cane",
      "candy-off",
      "carrot",
      "carton",
      "carton-off",
      "chef-hat",
      "cherry",
      "citrus",
      "coffee",
      "cookie",
      "cooking-pot",
      "croissant",
      "cuboid",
      "cup-soda",
      "cupcake",
      "dessert",
      "dna-off",
      "donut",
      "door-closed-package",
      "drumstick",
      "egg",
      "egg-fried",
      "egg-off",
      "faucet",
      "fish",
      "fish-off",
      "fish-symbol",
      "glass-water",
      "grape",
      "ham",
      "hamburger",
      "hand-platter",
      "hop",
      "hop-off",
      "ice-cream-bowl",
      "ice-cream-cone",
      "leafy-green",
      "lollipop",
      "martini",
      "microwave",
      "milk",
      "milk-off",
      "nut",
      "nut-off",
      "paper-bag",
      "pizza",
      "popcorn",
      "popsicle",
      "refrigerator",
      "salad",
      "sandwich",
      "shell",
      "shrimp",
      "shrimp-off",
      "snail",
      "soup",
      "torus",
      "tractor",
      "utensils",
      "utensils-crossed",
      "vegan",
      "wheat",
      "wheat-off",
      "wine",
      "wine-off",
    ],
  },
  {
    key: "gaming",
    label: "Gaming",
    names: [
      "amphora",
      "anvil",
      "arrow-big-down",
      "arrow-big-down-dash",
      "arrow-big-left",
      "arrow-big-left-dash",
      "arrow-big-right",
      "arrow-big-right-dash",
      "arrow-big-up",
      "arrow-big-up-dash",
      "award",
      "axe",
      "backpack",
      "beaker",
      "bone",
      "book",
      "book-a",
      "book-alert",
      "book-bookmark",
      "book-check",
      "book-copy",
      "book-heart",
      "book-key",
      "book-lock",
      "book-minus",
      "book-open",
      "book-open-check",
      "book-plus",
      "book-search",
      "book-text",
      "book-type",
      "book-x",
      "bow-arrow",
      "box",
      "boxes",
      "broom",
      "broom-sparkles",
      "castle",
      "chess-bishop",
      "chess-king",
      "chess-knight",
      "chess-pawn",
      "chess-queen",
      "chess-rook",
      "chevron-down",
      "chevron-up",
      "chevrons-down",
      "chevrons-left",
      "chevrons-left-right-ellipsis",
      "chevrons-right",
      "chevrons-up",
      "circle-arrow-down",
      "circle-arrow-left",
      "circle-arrow-right",
      "circle-arrow-up",
      "circle-plus",
      "circle-star",
      "clover",
      "club",
      "coins",
      "computer",
      "crown",
      "diamond",
      "dice-1",
      "dice-2",
      "dice-3",
      "dice-4",
      "dice-5",
      "dice-6",
      "dices",
      "droplet",
      "droplet-off",
      "ethernet-port",
      "feather",
      "flame",
      "flame-kindling",
      "flask-conical",
      "flask-conical-off",
      "flask-round",
      "flower",
      "gamepad",
      "gamepad-2",
      "gamepad-directional",
      "gem",
      "ghost",
      "gift",
      "goal",
      "gpu",
      "hdmi-port",
      "headphone-off",
      "headphones",
      "headset",
      "heart",
      "heart-minus",
      "heart-plus",
      "hourglass",
      "joystick",
      "land-plot",
      "medal",
      "memory-stick",
      "milestone",
      "monitor-pc",
      "mountain",
      "pc-case",
      "pickaxe",
      "playing-card",
      "playing-cards",
      "playing-cards-fan",
      "plus",
      "podium",
      "puzzle",
      "rectangle-goggles",
      "rocket",
      "scan",
      "scan-box",
      "scroll",
      "scroll-text",
      "shapes",
      "shield",
      "shield-alert",
      "shield-ban",
      "shield-check",
      "shield-cog",
      "shield-cog-corner",
      "shield-ellipsis",
      "shield-half",
      "shield-minus",
      "shield-off",
      "shield-plus",
      "shield-question-mark",
      "shield-x",
      "shovel",
      "signpost",
      "signpost-big",
      "skull",
      "spade",
      "sparkles",
      "sprout",
      "square-arrow-down",
      "square-arrow-down-left",
      "square-arrow-down-right",
      "square-star",
      "star",
      "star-check",
      "star-minus",
      "star-plus",
      "star-x",
      "sword",
      "swords",
      "tally-1",
      "tally-2",
      "tally-3",
      "tally-4",
      "tally-5",
      "target",
      "tic-tac-toe",
      "toy-brick",
      "trophy",
      "usb-c-port",
      "venetian-mask",
      "volleyball",
      "wand",
      "wand-sparkles",
    ],
  },
  {
    key: "home",
    label: "Home",
    names: [
      "air-vent",
      "alarm-smoke",
      "armchair",
      "bed",
      "bed-double",
      "bed-single",
      "bell-electric",
      "birdhouse",
      "blender",
      "blinds",
      "bolt",
      "brick-wall",
      "brick-wall-fire",
      "brick-wall-shield",
      "broom",
      "broom-sparkles",
      "brush-cleaning",
      "cooking-pot",
      "door-closed",
      "door-closed-cog",
      "door-closed-locked",
      "door-closed-package",
      "door-open",
      "door-stairwell",
      "drill",
      "fan",
      "faucet",
      "fence",
      "fire-extinguisher",
      "hammer",
      "heater",
      "house",
      "house-cog",
      "house-heart",
      "house-plug",
      "house-wifi",
      "houses",
      "lamp",
      "lamp-ceiling",
      "lamp-desk",
      "lamp-floor",
      "lamp-wall-down",
      "lamp-wall-up",
      "microwave",
      "mirror-rectangular",
      "mirror-round",
      "mop",
      "mop-sparkles",
      "paint-roller",
      "paintbrush",
      "paintbrush-vertical",
      "plant-pot",
      "refrigerator",
      "robot-vacuum",
      "rocking-chair",
      "rose",
      "router",
      "shell",
      "shelving-unit",
      "shower-head",
      "soap-dispenser-droplet",
      "sofa",
      "solar-panel",
      "swatch-book",
      "toilet",
      "tool-case",
      "toolbox",
      "toothbrush",
      "toothbrush-sparkles",
      "towel-rack",
      "tube-lotion",
      "turntable",
      "usb",
      "usb-c-port",
      "utility-pole",
      "vault",
      "washing-machine",
      "waves-ladder",
    ],
  },
  {
    key: "layout",
    label: "Layout",
    names: [
      "align-center-horizontal",
      "align-center-vertical",
      "align-end-horizontal",
      "align-end-vertical",
      "align-horizontal-distribute-center",
      "align-horizontal-distribute-end",
      "align-horizontal-distribute-start",
      "align-horizontal-justify-center",
      "align-horizontal-justify-end",
      "align-horizontal-justify-start",
      "align-horizontal-space-around",
      "align-horizontal-space-between",
      "align-start-horizontal",
      "align-start-vertical",
      "align-vertical-distribute-center",
      "align-vertical-distribute-end",
      "align-vertical-distribute-start",
      "align-vertical-justify-center",
      "align-vertical-justify-end",
      "align-vertical-justify-start",
      "align-vertical-space-around",
      "align-vertical-space-between",
      "app-window",
      "app-window-mac",
      "arrow-down-0-1",
      "arrow-down-1-0",
      "arrow-down-a-z",
      "arrow-down-narrow-wide",
      "arrow-down-wide-narrow",
      "arrow-down-z-a",
      "arrow-up-0-1",
      "arrow-up-1-0",
      "arrow-up-a-z",
      "arrow-up-narrow-wide",
      "arrow-up-wide-narrow",
      "arrow-up-z-a",
      "between-horizontal-end",
      "between-horizontal-start",
      "between-vertical-end",
      "between-vertical-start",
      "blocks",
      "bring-to-front",
      "circle-ellipsis",
      "columns-2",
      "columns-3",
      "columns-3-cog",
      "columns-4",
      "dock",
      "ellipsis",
      "ellipsis-vertical",
      "fold-horizontal",
      "fold-vertical",
      "fullscreen",
      "funnel",
      "funnel-plus",
      "funnel-x",
      "gallery-horizontal",
      "gallery-horizontal-end",
      "gallery-thumbnails",
      "gallery-vertical",
      "gallery-vertical-end",
      "gap-horizontal",
      "gap-vertical",
      "grid-2x2",
      "grid-2x2-check",
      "grid-2x2-plus",
      "grid-2x2-x",
      "grid-3x2",
      "grid-3x3",
      "grip",
      "grip-horizontal",
      "grip-vertical",
      "hand-grab",
      "layer-arrow-down",
      "layer-arrow-up",
      "layers",
      "layers-2",
      "layers-arrow-down",
      "layers-arrow-up",
      "layers-minus",
      "layers-plus",
      "layout-arrow-down",
      "layout-arrow-right",
      "layout-dashboard",
      "layout-freeform",
      "layout-grid",
      "layout-grid-circles",
      "layout-list",
      "layout-panel-left",
      "layout-panel-top",
      "layout-template",
      "list-filter-plus",
      "list-sort-ascending",
      "list-sort-descending",
      "list-tree",
      "loader",
      "loader-circle",
      "maximize",
      "maximize-2",
      "menu",
      "minimize",
      "minimize-2",
      "panel-bottom",
      "panel-bottom-close",
      "panel-bottom-dashed",
      "panel-bottom-open",
      "panel-left",
      "panel-left-close",
      "panel-left-dashed",
      "panel-left-open",
      "panel-left-right-dashed",
      "panel-right",
      "panel-right-close",
      "panel-right-dashed",
      "panel-right-open",
      "panel-top",
      "panel-top-bottom-dashed",
      "panel-top-close",
      "panel-top-dashed",
      "panel-top-open",
      "panels-left-bottom",
      "panels-right-bottom",
      "panels-top-left",
      "pencil-ruler",
      "proportions",
      "ratio",
      "rotate-ccw-square",
      "rotate-cw-square",
      "rows-2",
      "rows-3",
      "rows-4",
      "ruler",
      "ruler-dimension-line",
      "send-to-back",
      "separator-horizontal",
      "separator-vertical",
      "shrink",
      "square-arrow-right-enter",
      "square-arrow-right-exit",
      "square-dashed-plus",
      "square-dashed-top-solid",
      "square-dashed-x",
      "square-dashed-x-corner",
      "square-dimensions",
      "square-menu",
      "square-round-corner",
      "square-split-horizontal",
      "square-split-vertical",
      "square-square",
      "stretch-horizontal",
      "stretch-vertical",
      "text-cursor-input",
      "toggle-left",
      "toggle-right",
      "unfold-horizontal",
      "unfold-vertical",
      "zoom-in",
      "zoom-out",
    ],
  },
  {
    key: "mail",
    label: "Mail",
    names: [
      "archive",
      "archive-restore",
      "archive-x",
      "arrows-up-from-line",
      "container",
      "forward",
      "inbox",
      "mail",
      "mail-badge",
      "mail-check",
      "mail-clock",
      "mail-minus",
      "mail-open",
      "mail-pen",
      "mail-plus",
      "mail-question-mark",
      "mail-search",
      "mail-warning",
      "mail-x",
      "mailbox",
      "mails",
      "paperclip",
      "reply",
      "reply-all",
      "send",
      "send-horizontal",
      "shredder",
      "trash",
      "trash-off",
    ],
  },
  {
    key: "math",
    label: "Math",
    names: [
      "angle",
      "asterisk",
      "astroid",
      "badge-percent",
      "box",
      "calculator",
      "chevron-right",
      "chevron-up",
      "circle-divide",
      "circle-equal",
      "circle-minus",
      "circle-percent",
      "circle-plus",
      "circle-slash",
      "circle-slash-2",
      "circle-x",
      "cone",
      "copy-minus",
      "copy-plus",
      "copy-slash",
      "copy-x",
      "cuboid",
      "cylinder",
      "decimals-arrow-left",
      "decimals-arrow-right",
      "diameter",
      "diamond-percent",
      "divide",
      "drafting-compass",
      "equal",
      "equal-approximately",
      "equal-approximately-not",
      "equal-not",
      "grid-2x2",
      "grid-2x2-check",
      "grid-2x2-plus",
      "grid-2x2-x",
      "grid-3x2",
      "lambda",
      "land-plot",
      "line-squiggle",
      "minus",
      "octagon-x",
      "omega",
      "parentheses",
      "percent",
      "phi",
      "pi",
      "plus",
      "pyramid",
      "radical",
      "radius",
      "sigma",
      "slash",
      "square-asterisk",
      "square-chevron-up",
      "square-divide",
      "square-equal",
      "square-function",
      "square-minus",
      "square-percent",
      "square-pi",
      "square-plus",
      "square-radical",
      "square-sigma",
      "square-slash",
      "square-x",
      "tally-1",
      "tally-2",
      "tally-3",
      "tally-4",
      "tally-5",
      "tangent",
      "triangle-right",
      "variable",
      "vector-polygon",
      "vector-square",
      "weight",
      "weight-tilde",
      "x",
      "x-line-top",
    ],
  },
  {
    key: "medical",
    label: "Medical",
    names: [
      "accessibility",
      "activity",
      "ambulance",
      "bandage",
      "bone",
      "bone-fracture",
      "brain",
      "briefcase-medical",
      "cigarette",
      "cigarette-off",
      "circle-small",
      "clipboard-minus",
      "clipboard-plus",
      "dna",
      "dna-off",
      "ear",
      "ear-off",
      "fingerprint-pattern",
      "germ",
      "germ-off",
      "heart",
      "heart-minus",
      "heart-plus",
      "heart-pulse",
      "hospital",
      "house-heart",
      "house-plus",
      "iv-bag",
      "life-buoy",
      "mars",
      "mars-stroke",
      "microscope",
      "mouth",
      "mouth-off",
      "non-binary",
      "pill",
      "pill-bottle",
      "ribbon",
      "scan-heart",
      "shield-plus",
      "siren",
      "square-activity",
      "stethoscope",
      "syringe",
      "tablets",
      "toothbrush",
      "toothbrush-sparkles",
      "transgender",
      "tube-lotion",
      "venus",
      "venus-and-mars",
      "virus",
      "virus-off",
    ],
  },
  {
    key: "multimedia",
    label: "Multimedia",
    names: [
      "activity",
      "ad",
      "airplay",
      "antenna",
      "audio-lines",
      "audio-lines-off",
      "audio-lines-x",
      "audio-waveform",
      "book-audio",
      "book-headphones",
      "book-image",
      "boom-box",
      "cable",
      "captions",
      "captions-off",
      "card-sim",
      "cassette-tape",
      "chevron-first",
      "chevron-last",
      "chevrons-left-right-ellipsis",
      "circle-pause",
      "circle-play",
      "circle-stop",
      "clapperboard",
      "clef-alto",
      "clef-bass",
      "clef-treble",
      "closed-caption",
      "diamond-minus",
      "diamond-plus",
      "disc",
      "disc-2",
      "disc-3",
      "disc-album",
      "drama",
      "drum",
      "eject",
      "ethernet-port",
      "fast-forward",
      "file-music",
      "film",
      "fullscreen",
      "gallery-horizontal",
      "gallery-horizontal-end",
      "gallery-thumbnails",
      "gallery-vertical",
      "gallery-vertical-end",
      "guitar",
      "hand-metal",
      "hd",
      "hdmi-port",
      "headphone-off",
      "headphones",
      "headset",
      "heart",
      "heart-minus",
      "heart-off",
      "heart-plus",
      "heart-x",
      "image",
      "image-down",
      "image-minus",
      "image-off",
      "image-play",
      "image-plus",
      "image-up",
      "image-upscale",
      "images",
      "infinity",
      "keyboard-music",
      "lectern",
      "library",
      "library-big",
      "list-end",
      "list-minus",
      "list-music",
      "list-plus",
      "list-restart",
      "list-start",
      "list-video",
      "list-x",
      "loader",
      "loader-circle",
      "megaphone",
      "megaphone-off",
      "metronome",
      "mic",
      "mic-audio-lines",
      "mic-off",
      "mic-signal",
      "mic-vocal",
      "midi-port",
      "monitor-pause",
      "monitor-play",
      "monitor-stop",
      "music",
      "music-2",
      "music-3",
      "music-4",
      "newspaper",
      "octagon-pause",
      "pause",
      "piano",
      "picture-in-picture",
      "picture-in-picture-2",
      "play",
      "play-off",
      "popcorn",
      "presentation",
      "projector",
      "radio",
      "radio-off",
      "radio-tower",
      "rectangle-goggles",
      "repeat",
      "repeat-1",
      "repeat-2",
      "repeat-off",
      "rewind",
      "satellite-dish",
      "scan-eye",
      "scan-search",
      "shuffle",
      "skip-back",
      "skip-forward",
      "sparkles",
      "speaker",
      "spotlight",
      "square",
      "square-activity",
      "square-arrow-right-enter",
      "square-arrow-right-exit",
      "square-bookmark",
      "square-library",
      "square-pause",
      "square-play",
      "square-sparkles",
      "square-stop",
      "star",
      "star-check",
      "star-half",
      "star-minus",
      "star-off",
      "star-plus",
      "star-x",
      "step-back",
      "step-forward",
      "turntable",
      "tv",
      "tv-minimal",
      "tv-minimal-play",
      "usb",
      "usb-c-port",
      "volume",
      "volume-1",
      "volume-2",
      "volume-off",
      "volume-x",
      "waves-horizontal",
    ],
  },
  {
    key: "nature",
    label: "Nature",
    names: [
      "binoculars",
      "birdhouse",
      "cannabis",
      "cannabis-off",
      "caravan",
      "feather",
      "flame-kindling",
      "flower",
      "flower-2",
      "leaf",
      "mountain",
      "mountain-snow",
      "park",
      "plant-pot",
      "rose",
      "shell",
      "shovel",
      "shrub",
      "sprout",
      "stone",
      "tent",
      "tent-tree",
      "tree-deciduous",
      "tree-palm",
      "tree-pine",
      "trees",
    ],
  },
  {
    key: "navigation",
    label: "Navigation",
    names: [
      "barrel",
      "binoculars",
      "birdhouse",
      "calendar-chevrons-right",
      "castle",
      "church",
      "circle-parking",
      "circle-parking-off",
      "compass",
      "credit-card-reader",
      "dam",
      "dome",
      "dumbbell",
      "earth",
      "ev-charger",
      "factory",
      "faucet",
      "ferris-wheel",
      "flag-triangle-left",
      "flag-triangle-right",
      "footprints",
      "fuel",
      "gavel",
      "git-commit-horizontal",
      "git-commit-vertical",
      "globe",
      "globe-check",
      "globe-code",
      "globe-off",
      "globe-x",
      "hospital",
      "hotel",
      "house",
      "landmark",
      "library",
      "library-big",
      "lighthouse",
      "line-dot-bottom-vertical",
      "line-dot-left-horizontal",
      "line-dot-right-horizontal",
      "line-dot-top-vertical",
      "locate",
      "locate-fixed",
      "locate-off",
      "map",
      "map-minus",
      "map-pin",
      "map-pin-check",
      "map-pin-check-inside",
      "map-pin-house",
      "map-pin-minus",
      "map-pin-minus-inside",
      "map-pin-off",
      "map-pin-pen",
      "map-pin-plus",
      "map-pin-plus-inside",
      "map-pin-search",
      "map-pin-x",
      "map-pin-x-inside",
      "map-pinned",
      "map-plus",
      "milestone",
      "mosque",
      "navigation",
      "navigation-2",
      "navigation-2-off",
      "navigation-off",
      "park",
      "parking-meter",
      "pin",
      "pin-off",
      "plane",
      "radar",
      "roller-coaster",
      "route",
      "route-off",
      "scale",
      "school",
      "ship",
      "ship-cargo",
      "ship-wheel",
      "signpost",
      "signpost-big",
      "square-chevron-down",
      "square-chevron-left",
      "square-chevron-right",
      "square-chevron-up",
      "square-library",
      "square-m",
      "square-parking",
      "square-parking-off",
      "store",
      "train-front-tunnel",
      "train-track",
      "university",
      "utensils",
      "utensils-crossed",
      "warehouse",
      "waves-horizontal",
      "waypoints",
      "wind-arrow-up",
    ],
  },
  {
    key: "notifications",
    label: "Notifications",
    names: [
      "ad",
      "alarm-clock",
      "alarm-clock-check",
      "alarm-clock-minus",
      "alarm-clock-off",
      "alarm-clock-plus",
      "bell",
      "bell-check",
      "bell-dot",
      "bell-electric",
      "bell-minus",
      "bell-off",
      "bell-plus",
      "bell-ring",
      "check",
      "check-check",
      "check-line",
      "circle-alert",
      "circle-check",
      "circle-check-big",
      "circle-dashed-check",
      "circle-question-mark",
      "copy-check",
      "copy-x",
      "face-slightly-smiling-plus",
      "file-exclamation-point",
      "info",
      "laptop-minimal-check",
      "list-clock",
      "mail-clock",
      "megaphone",
      "megaphone-off",
      "message-circle-warning",
      "message-square-dot",
      "message-square-warning",
      "messages-circle",
      "octagon-alert",
      "octagon-x",
      "shield-alert",
      "square-check",
      "square-check-big",
      "square-exclamation-point",
      "square-x",
      "triangle-alert",
      "vibrate",
      "whistle",
      "x",
      "x-line-top",
    ],
  },
  {
    key: "people",
    label: "People",
    names: [
      "baby",
      "clock-arrow-right",
      "hand-platter",
      "person-standing",
      "user-group",
      "user-round-arrow-left",
      "user-round-group",
      "user-shield",
    ],
  },
  {
    key: "photography",
    label: "Photography",
    names: [
      "aperture",
      "backpack",
      "binoculars",
      "blend",
      "book-image",
      "camera",
      "camera-off",
      "cctv",
      "cctv-off",
      "contrast",
      "crop",
      "crosshair",
      "database-backup",
      "diamond-minus",
      "diamond-plus",
      "eclipse",
      "eye",
      "eye-closed",
      "eye-dashed",
      "eye-off",
      "film",
      "flashlight",
      "flashlight-off",
      "focus",
      "frame",
      "fullscreen",
      "gallery-horizontal",
      "gallery-horizontal-end",
      "gallery-thumbnails",
      "gallery-vertical",
      "gallery-vertical-end",
      "image",
      "image-down",
      "image-minus",
      "image-off",
      "image-play",
      "image-plus",
      "image-up",
      "image-upscale",
      "images",
      "layout-list",
      "library",
      "library-big",
      "lightbulb",
      "lightbulb-off",
      "paintbrush",
      "paintbrush-vertical",
      "palette",
      "pencil-sparkles",
      "presentation",
      "projector",
      "proportions",
      "ratio",
      "rotate-ccw",
      "rotate-ccw-square",
      "rotate-cw",
      "rotate-cw-square",
      "scan-eye",
      "scan-search",
      "scan-square",
      "spotlight",
      "square-bookmark",
      "square-centerline-dashed-horizontal",
      "square-centerline-dashed-vertical",
      "square-library",
      "square-sparkles",
      "swatch-book",
      "triangles-centerline-dashed-horizontal",
      "triangles-centerline-dashed-vertical",
      "video",
      "video-off",
      "videotape",
      "view",
      "wand",
      "wand-sparkles",
      "zap",
      "zap-off",
      "zoom-in",
      "zoom-out",
    ],
  },
  {
    key: "science",
    label: "Science",
    names: [
      "activity",
      "atom",
      "beaker",
      "binoculars",
      "biohazard",
      "brain",
      "brain-circuit",
      "brain-cog",
      "circle-gauge",
      "circuit-board",
      "eclipse",
      "equal-approximately-not",
      "flask-conical",
      "flask-conical-off",
      "flask-round",
      "galaxy",
      "gauge",
      "germ",
      "germ-off",
      "lambda",
      "lens-concave",
      "lens-convex",
      "microscope",
      "mirror-rectangular",
      "mirror-round",
      "omega",
      "orbit",
      "phi",
      "pipette",
      "radiation",
      "robot-arm",
      "satellite",
      "scale",
      "shell",
      "sigma",
      "solar-panel",
      "square-activity",
      "stethoscope",
      "syringe",
      "telescope",
      "test-tube",
      "test-tube-diagonal",
      "test-tubes",
      "virus",
      "virus-off",
    ],
  },
  {
    key: "seasons",
    label: "Seasons",
    names: ["flower-2", "leaf", "rose", "snowflake", "sun", "tube-lotion"],
  },
  {
    key: "security",
    label: "Security",
    names: [
      "bomb",
      "book-key",
      "book-lock",
      "brick-wall-fire",
      "brick-wall-shield",
      "cctv",
      "cctv-off",
      "columns-4",
      "door-closed",
      "door-closed-cog",
      "door-closed-locked",
      "door-open",
      "earth-lock",
      "eye",
      "eye-closed",
      "eye-dashed",
      "eye-off",
      "file-key",
      "file-lock",
      "fingerprint-pattern",
      "folder-key",
      "folder-lock",
      "germ",
      "germ-off",
      "globe-lock",
      "handshake",
      "hat-glasses",
      "heart-handshake",
      "id-card",
      "id-card-lanyard",
      "key",
      "key-round",
      "key-square",
      "lock",
      "lock-keyhole",
      "lock-keyhole-open",
      "lock-open",
      "mail-badge",
      "radar",
      "rotate-ccw-key",
      "scan",
      "scan-eye",
      "scan-face",
      "scan-qr-code",
      "shield",
      "shield-alert",
      "shield-ban",
      "shield-check",
      "shield-cog",
      "shield-cog-corner",
      "shield-ellipsis",
      "shield-half",
      "shield-keyhole",
      "shield-lock",
      "shield-minus",
      "shield-off",
      "shield-plus",
      "shield-question-mark",
      "shield-user",
      "shield-x",
      "square-asterisk",
      "user-lock",
      "user-shield",
      "vault",
      "virus",
      "virus-off",
      "waypoints",
      "worm",
    ],
  },
  {
    key: "shapes",
    label: "Shapes",
    names: [
      "astroid",
      "badge",
      "badge-question-mark",
      "blocks",
      "box",
      "boxes",
      "circle",
      "circle-dashed",
      "circle-dashed-check",
      "circle-dot",
      "circle-dot-dashed",
      "circle-off",
      "circle-pile",
      "circle-slash-2",
      "circle-small",
      "club",
      "cone",
      "cross",
      "cuboid",
      "cylinder",
      "diameter",
      "diamond",
      "dot",
      "ellipse",
      "heart",
      "heart-x",
      "hexagon",
      "lens-concave",
      "lens-convex",
      "line-squiggle",
      "octagon",
      "octagon-alert",
      "octagon-pause",
      "pentagon",
      "pyramid",
      "radius",
      "rectangle-horizontal",
      "rectangle-vertical",
      "shapes",
      "shield",
      "shield-cog",
      "shield-cog-corner",
      "spade",
      "sparkle",
      "square",
      "square-arrow-right-enter",
      "square-arrow-right-exit",
      "square-dashed-plus",
      "square-exclamation-point",
      "square-off",
      "square-text",
      "squircle",
      "squircle-dashed",
      "star",
      "star-check",
      "star-minus",
      "star-plus",
      "star-x",
      "tangent",
      "torus",
      "triangle",
      "triangle-alert",
      "triangle-dashed",
      "triangle-right",
      "ungroup",
      "vector-polygon",
      "vector-square",
    ],
  },
  {
    key: "shopping",
    label: "Shopping",
    names: [
      "badge-cent",
      "badge-dollar-sign",
      "badge-euro",
      "badge-indian-rupee",
      "badge-japanese-yen",
      "badge-percent",
      "badge-pound-sterling",
      "badge-russian-ruble",
      "badge-swiss-franc",
      "badge-turkish-lira",
      "bangladeshi-taka",
      "barcode",
      "book-image",
      "circle-euro",
      "circle-percent",
      "credit-card-check",
      "credit-card-minus",
      "credit-card-plus",
      "credit-card-reader",
      "credit-card-x",
      "diamond-percent",
      "handbag",
      "nepali-rupee",
      "paper-bag",
      "percent",
      "scan",
      "scan-barcode",
      "scan-box",
      "scan-line",
      "scan-qr-code",
      "shirt",
      "shopping-bag",
      "shopping-basket",
      "shopping-cart",
      "shopping-cart-minus",
      "shopping-cart-plus",
      "square-percent",
      "store",
      "ticket-percent",
      "tube-lotion",
    ],
  },
  {
    key: "social",
    label: "Social",
    names: [
      "activity",
      "badge",
      "badge-alert",
      "badge-check",
      "badge-info",
      "badge-minus",
      "badge-percent",
      "badge-plus",
      "badge-question-mark",
      "badge-x",
      "book-heart",
      "book-image",
      "book-user",
      "boom-box",
      "bot",
      "bot-message-square",
      "bot-off",
      "cake",
      "cake-slice",
      "circle-fading-plus",
      "circle-percent",
      "contact",
      "contact-round",
      "diamond-percent",
      "external-link",
      "face-slightly-smiling-plus",
      "flag",
      "flag-off",
      "flame",
      "flame-kindling",
      "hand-fist",
      "hand-heart",
      "handshake",
      "hash",
      "hat-glasses",
      "heart",
      "heart-minus",
      "heart-off",
      "heart-plus",
      "heart-x",
      "message-circle",
      "message-circle-check",
      "message-circle-code",
      "message-circle-dashed",
      "message-circle-dashed-check",
      "message-circle-heart",
      "message-circle-more",
      "message-circle-off",
      "message-circle-plus",
      "message-circle-question-mark",
      "message-circle-reply",
      "message-circle-warning",
      "message-circle-x",
      "message-square",
      "message-square-check",
      "message-square-code",
      "message-square-dashed",
      "message-square-diff",
      "message-square-dot",
      "message-square-heart",
      "message-square-lock",
      "message-square-more",
      "message-square-off",
      "message-square-plus",
      "message-square-quote",
      "message-square-reply",
      "message-square-share",
      "message-square-text",
      "message-square-warning",
      "message-square-x",
      "messages-circle",
      "messages-square",
      "notebook",
      "notebook-pen",
      "notebook-tabs",
      "notebook-text",
      "notepad-text",
      "notepad-text-dashed",
      "playing-cards-fan",
      "qr-code",
      "radio",
      "radio-off",
      "radio-tower",
      "repeat-2",
      "ribbon",
      "rose",
      "rss",
      "scan",
      "scan-face",
      "search",
      "search-alert",
      "search-check",
      "search-code",
      "search-slash",
      "search-x",
      "share",
      "share-2",
      "spool",
      "square-activity",
      "square-arrow-out-up-right",
      "square-arrow-up-right",
      "square-percent",
      "star",
      "star-check",
      "star-half",
      "star-minus",
      "star-off",
      "star-plus",
      "star-x",
      "sticker",
      "sticky-note",
      "sticky-note-check",
      "sticky-note-minus",
      "sticky-note-off",
      "sticky-note-plus",
      "sticky-note-x",
      "sticky-notes",
      "theater",
      "thumbs-down",
      "thumbs-up",
      "user-group",
      "user-round-group",
      "user-round-search",
      "user-search",
      "voicemail",
      "vote",
      "waypoints",
      "webhook",
      "webhook-off",
      "zodiac-aquarius",
      "zodiac-aries",
      "zodiac-cancer",
      "zodiac-capricorn",
      "zodiac-gemini",
      "zodiac-leo",
      "zodiac-libra",
      "zodiac-ophiuchus",
      "zodiac-pisces",
      "zodiac-sagittarius",
      "zodiac-scorpio",
      "zodiac-taurus",
      "zodiac-virgo",
    ],
  },
  {
    key: "sports",
    label: "Sports",
    names: [
      "award",
      "circle-gauge",
      "circle-star",
      "dumbbell",
      "fishing-hook",
      "fishing-rod",
      "gauge",
      "hand-fist",
      "land-plot",
      "medal",
      "podium",
      "rugby-ball",
      "sport-shoe",
      "square-star",
      "trophy",
      "volleyball",
      "waves-ladder",
      "whistle",
    ],
  },
  {
    key: "sustainability",
    label: "Sustainability",
    names: [
      "dam",
      "flower",
      "flower-2",
      "house-plug",
      "leaf",
      "leafy-green",
      "recycle",
      "rose",
      "solar-panel",
      "sprout",
      "sun",
      "tent",
      "tractor",
      "tree-deciduous",
      "tree-palm",
      "tree-pine",
      "trees",
      "utility-pole",
      "vegan",
      "waves-arrow-down",
      "waves-arrow-up",
      "waves-horizontal",
      "waves-vertical",
      "wind",
      "wind-arrow-down",
      "wind-arrow-up",
    ],
  },
  {
    key: "text",
    label: "Text",
    names: [
      "a-arrow-down",
      "a-arrow-up",
      "a-large-small",
      "ampersand",
      "ampersands",
      "anchor",
      "arrow-big-up",
      "arrow-big-up-dash",
      "arrow-down-0-1",
      "arrow-down-1-0",
      "arrow-down-a-z",
      "arrow-down-narrow-wide",
      "arrow-down-wide-narrow",
      "arrow-down-z-a",
      "arrow-up-0-1",
      "arrow-up-1-0",
      "arrow-up-a-z",
      "arrow-up-narrow-wide",
      "arrow-up-wide-narrow",
      "arrow-up-z-a",
      "asterisk",
      "at-sign",
      "baseline",
      "binary",
      "bold",
      "book",
      "book-a",
      "book-alert",
      "book-audio",
      "book-bookmark",
      "book-check",
      "book-copy",
      "book-headphones",
      "book-heart",
      "book-image",
      "book-minus",
      "book-open",
      "book-open-check",
      "book-open-text",
      "book-plus",
      "book-search",
      "book-text",
      "book-type",
      "book-x",
      "brush",
      "case-lower",
      "case-sensitive",
      "case-upper",
      "circle-question-mark",
      "clipboard",
      "clipboard-check",
      "clipboard-clock",
      "clipboard-copy",
      "clipboard-list",
      "clipboard-minus",
      "clipboard-paste",
      "clipboard-pen",
      "clipboard-pen-line",
      "clipboard-plus",
      "clipboard-type",
      "clipboard-x",
      "code",
      "code-xml",
      "columns-2",
      "columns-3",
      "columns-4",
      "copy",
      "copy-check",
      "copy-minus",
      "copy-plus",
      "copy-slash",
      "copyleft",
      "copyright",
      "corner-down-right",
      "creative-commons",
      "decimals-arrow-left",
      "decimals-arrow-right",
      "delete",
      "dot",
      "eraser",
      "expand",
      "external-link",
      "feather",
      "file-text",
      "file-type",
      "file-type-corner",
      "grid-2x2",
      "grid-2x2-check",
      "grid-2x2-plus",
      "grid-2x2-x",
      "grid-3x2",
      "grid-3x3",
      "hash",
      "heading",
      "heading-1",
      "heading-2",
      "heading-3",
      "heading-4",
      "heading-5",
      "heading-6",
      "highlighter",
      "image",
      "image-down",
      "image-play",
      "image-up",
      "images",
      "italic",
      "keyboard",
      "keyboard-off",
      "lambda",
      "languages",
      "layout-list",
      "letters",
      "library",
      "library-big",
      "ligature",
      "link",
      "link-2",
      "link-2-off",
      "list",
      "list-check",
      "list-checks",
      "list-chevrons-down-up",
      "list-chevrons-up-down",
      "list-clock",
      "list-collapse",
      "list-end",
      "list-filter",
      "list-filter-plus",
      "list-indent-decrease",
      "list-indent-increase",
      "list-minus",
      "list-ordered",
      "list-plus",
      "list-restart",
      "list-sort-ascending",
      "list-sort-descending",
      "list-start",
      "list-todo",
      "list-tree",
      "list-x",
      "logs",
      "mail",
      "mail-clock",
      "map",
      "map-pin-search",
      "message-square-quote",
      "minus",
      "notebook",
      "notebook-pen",
      "notebook-text",
      "notepad-text",
      "notepad-text-dashed",
      "omega",
      "paint-roller",
      "paintbrush",
      "paintbrush-vertical",
      "palette",
      "paperclip",
      "pen",
      "pen-line",
      "pen-off",
      "pen-tool",
      "pencil",
      "pencil-line",
      "pencil-off",
      "pencil-ruler",
      "pencil-sparkles",
      "phone",
      "pilcrow",
      "pilcrow-left",
      "pilcrow-right",
      "pipette",
      "plus",
      "quote",
      "rectangle-circle",
      "rectangle-ellipsis",
      "redo",
      "redo-2",
      "redo-dot",
      "regex",
      "remove-formatting",
      "replace",
      "replace-all",
      "rows-2",
      "rows-3",
      "rows-4",
      "save",
      "save-all",
      "save-check",
      "save-off",
      "save-pen",
      "save-plus",
      "scan-text",
      "scissors",
      "scroll",
      "scroll-text",
      "search",
      "search-alert",
      "search-check",
      "search-code",
      "search-slash",
      "search-x",
      "section",
      "separator-horizontal",
      "separator-vertical",
      "sheet",
      "sigma",
      "signature",
      "space",
      "spell-check",
      "spell-check-2",
      "square-asterisk",
      "square-bottom-dashed-scissors",
      "square-code",
      "square-dashed",
      "square-dashed-text",
      "square-library",
      "square-minus",
      "square-pen",
      "square-pilcrow",
      "square-plus",
      "square-scissors",
      "square-sigma",
      "square-sparkles",
      "square-stack",
      "square-text",
      "sticky-note",
      "sticky-note-check",
      "sticky-note-minus",
      "sticky-note-off",
      "sticky-note-plus",
      "sticky-note-x",
      "sticky-notes",
      "strikethrough",
      "subscript",
      "summary",
      "superscript",
      "table",
      "table-2",
      "table-cells-merge",
      "table-cells-split",
      "table-columns-split",
      "table-of-contents",
      "table-properties",
      "table-rows-split",
      "text-align-center",
      "text-align-end",
      "text-align-justify",
      "text-align-justify-center",
      "text-align-justify-end",
      "text-align-justify-start",
      "text-align-start",
      "text-cursor",
      "text-cursor-input",
      "text-initial",
      "text-quote",
      "text-search",
      "text-wrap",
      "type",
      "type-outline",
      "underline",
      "undo",
      "undo-2",
      "undo-dot",
      "unlink",
      "unlink-2",
      "whole-word",
      "zoom-in",
      "zoom-out",
    ],
  },
  {
    key: "time",
    label: "Time",
    names: [
      "alarm-clock",
      "alarm-clock-check",
      "alarm-clock-minus",
      "alarm-clock-off",
      "alarm-clock-plus",
      "calendar",
      "calendar-1",
      "calendar-arrow-down",
      "calendar-arrow-up",
      "calendar-check",
      "calendar-check-2",
      "calendar-chevrons-right",
      "calendar-clock",
      "calendar-cog",
      "calendar-days",
      "calendar-fold",
      "calendar-heart",
      "calendar-minus",
      "calendar-minus-2",
      "calendar-off",
      "calendar-plus",
      "calendar-plus-2",
      "calendar-range",
      "calendar-search",
      "calendar-sync",
      "calendar-x",
      "calendar-x-2",
      "calendars",
      "chart-no-axes-gantt",
      "clipboard-clock",
      "clock",
      "clock-1",
      "clock-10",
      "clock-11",
      "clock-12",
      "clock-2",
      "clock-3",
      "clock-4",
      "clock-5",
      "clock-6",
      "clock-7",
      "clock-8",
      "clock-9",
      "clock-alert",
      "clock-arrow-down",
      "clock-arrow-left",
      "clock-arrow-right",
      "clock-arrow-up",
      "clock-check",
      "clock-fading",
      "clock-plus",
      "file-clock",
      "folder-clock",
      "hourglass",
      "hourglass-cog",
      "list-clock",
      "mail-clock",
      "metronome",
      "rotate-ccw-clock",
      "rotate-cw-clock",
      "rotate-cw-fading-clock",
      "square-chart-gantt",
      "sunrise",
      "timeline",
      "timer",
      "timer-off",
      "timer-reset",
      "watch",
    ],
  },
  {
    key: "tools",
    label: "Tools",
    names: [
      "anvil",
      "axe",
      "between-horizontal-end",
      "between-horizontal-start",
      "between-vertical-end",
      "between-vertical-start",
      "blend",
      "bolt",
      "bomb",
      "bow-arrow",
      "broom",
      "broom-sparkles",
      "brush",
      "brush-cleaning",
      "diameter",
      "diamond-minus",
      "diamond-plus",
      "drafting-compass",
      "drill",
      "fire-extinguisher",
      "gavel",
      "hammer",
      "hard-hat",
      "hourglass-cog",
      "inspection-panel",
      "land-plot",
      "lens-concave",
      "lens-convex",
      "line-style",
      "minus",
      "mirror-rectangular",
      "mirror-round",
      "mop",
      "mop-sparkles",
      "paint-bucket",
      "paint-roller",
      "paintbrush",
      "paintbrush-vertical",
      "pen",
      "pen-line",
      "pen-off",
      "pencil",
      "pencil-line",
      "pencil-off",
      "pencil-ruler",
      "pencil-sparkles",
      "pickaxe",
      "plus",
      "pocket-knife",
      "printer-3d",
      "radius",
      "robot-arm",
      "robot-vacuum",
      "rotate-ccw-square",
      "rotate-cw-square",
      "ruler",
      "ruler-dimension-line",
      "scissors",
      "scissors-line-dashed",
      "shovel",
      "spline-pointer",
      "spool",
      "spray-can",
      "square-bottom-dashed-scissors",
      "square-dashed-mouse-pointer",
      "square-minus",
      "square-mouse-pointer",
      "square-plus",
      "square-scissors",
      "stamp",
      "sword",
      "swords",
      "tablet-smartphone",
      "tangent",
      "telescope",
      "tool-case",
      "toolbox",
      "toothbrush",
      "toothbrush-sparkles",
      "torus",
      "vector-square",
      "wrench",
      "wrench-off",
    ],
  },
  {
    key: "transportation",
    label: "Transportation",
    names: [
      "ambulance",
      "anchor",
      "arrows-up-from-line",
      "baggage-claim",
      "bike",
      "bridge",
      "briefcase",
      "briefcase-business",
      "briefcase-conveyor-belt",
      "briefcase-medical",
      "briefcase-plus",
      "bus",
      "bus-front",
      "cable-car",
      "car",
      "car-battery",
      "car-front",
      "car-taxi-front",
      "caravan",
      "cigarette",
      "cigarette-off",
      "circle-gauge",
      "circle-parking",
      "circle-parking-off",
      "container",
      "door-closed-package",
      "drone",
      "engine",
      "ev-charger",
      "forklift",
      "fuel",
      "gauge",
      "handbag",
      "helicopter",
      "kayak",
      "luggage",
      "motorbike",
      "octagon-minus",
      "parking-meter",
      "plane",
      "plane-landing",
      "plane-takeoff",
      "road",
      "sailboat",
      "scooter",
      "ship",
      "ship-cargo",
      "ship-wheel",
      "square-m",
      "square-parking",
      "square-parking-off",
      "ticket",
      "ticket-check",
      "ticket-minus",
      "ticket-percent",
      "ticket-plus",
      "ticket-slash",
      "ticket-x",
      "tickets",
      "tickets-plane",
      "tower-control",
      "tractor",
      "traffic-cone",
      "trailer",
      "train-front",
      "train-front-tunnel",
      "train-track",
      "tram-front",
      "truck",
      "truck-electric",
      "van",
    ],
  },
  {
    key: "travel",
    label: "Travel",
    names: [
      "alarm-smoke",
      "backpack",
      "baggage-claim",
      "bangladeshi-taka",
      "bath",
      "binoculars",
      "book-image",
      "bridge",
      "briefcase-conveyor-belt",
      "cable-car",
      "caravan",
      "cigarette",
      "cigarette-off",
      "compass",
      "concierge-bell",
      "dome",
      "door-closed",
      "door-closed-locked",
      "door-open",
      "door-stairwell",
      "faucet",
      "fire-extinguisher",
      "fishing-hook",
      "fishing-rod",
      "heater",
      "helicopter",
      "hospital",
      "hotel",
      "lighthouse",
      "luggage",
      "map-minus",
      "map-pin",
      "map-pin-check",
      "map-pin-check-inside",
      "map-pin-house",
      "map-pin-minus",
      "map-pin-minus-inside",
      "map-pin-off",
      "map-pin-pen",
      "map-pin-plus",
      "map-pin-plus-inside",
      "map-pin-search",
      "map-pin-x",
      "map-pin-x-inside",
      "map-pinned",
      "mosque",
      "nepali-rupee",
      "parasol",
      "park",
      "plane",
      "plane-landing",
      "plane-takeoff",
      "pyramid",
      "receipt",
      "receipt-cent",
      "receipt-euro",
      "receipt-indian-rupee",
      "receipt-japanese-yen",
      "receipt-pound-sterling",
      "receipt-russian-ruble",
      "receipt-swiss-franc",
      "receipt-text",
      "receipt-turkish-lira",
      "sailboat",
      "shell",
      "ship",
      "ship-cargo",
      "ship-wheel",
      "shower-head",
      "soap-dispenser-droplet",
      "tent",
      "tent-tree",
      "tickets",
      "tickets-plane",
      "toothbrush",
      "toothbrush-sparkles",
      "towel-rack",
      "tower-control",
      "tube-lotion",
      "utensils",
      "utensils-crossed",
      "vault",
      "volleyball",
      "washing-machine",
    ],
  },
  {
    key: "weather",
    label: "Weather",
    names: [
      "bubbles",
      "cloud",
      "cloud-drizzle",
      "cloud-fog",
      "cloud-hail",
      "cloud-lightning",
      "cloud-moon",
      "cloud-moon-rain",
      "cloud-off",
      "cloud-rain",
      "cloud-rain-wind",
      "cloud-snow",
      "cloud-sun",
      "cloud-sun-rain",
      "cloudy",
      "droplet",
      "droplet-off",
      "droplets",
      "flame",
      "haze",
      "moon-star",
      "parasol",
      "rainbow",
      "snowflake",
      "solar-panel",
      "sparkles",
      "star",
      "star-check",
      "star-minus",
      "star-plus",
      "star-x",
      "sun",
      "sun-dim",
      "sun-medium",
      "sun-snow",
      "sunrise",
      "sunset",
      "thermometer",
      "thermometer-snowflake",
      "thermometer-sun",
      "tornado",
      "umbrella",
      "umbrella-off",
      "waves-arrow-down",
      "waves-arrow-up",
      "waves-horizontal",
      "waves-vertical",
      "wind",
      "wind-arrow-down",
      "wind-arrow-up",
      "zap",
      "zap-off",
    ],
  },
];
